module.exports = __webpack_public_path__ + "static/media/education.5e4558f1.svg";